<template>
  <div>
    <elsa-tree accordion icon-class="tree-icon" :data="treeData" v-on:assign="handleAssign">
      <template v-slot:title="{ node }">
        <span v-bind:class="node.data.options.titleClassArray">
          {{ getTitlel(node.data) }}
        </span>
      </template>
      <template v-slot:subtitle="{ node }">
        <span class="subtitle">{{ node.data.textSubTitle }}</span>
      </template>
      <template v-slot:tags="{ node }">
        <span v-if="node.data.cefr_level" class="tag">{{ node.data.cefr_level }}</span>
      </template>
      <template v-slot:customContent="{ node }">
        <detail-goals :data="node.data" />
      </template>
    </elsa-tree>
    <add-assignment-wrapper ref="addAssignment" />
  </div>
</template>

<script>
import ElsaTree from "@/components/common/Tree";
import { mappingLevel } from "@/constants/elsaAI";
import { deepClone } from "@/utils/common";
import DetailGoals from "@/components/scenario/DetailGoals";
import AddAssignmentWrapper from "@/components/modals/scenario/AddAssignmentWrapper";

export default {
  components: {
    ElsaTree,
    DetailGoals,
    AddAssignmentWrapper,
  },
  props: {
    data: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      treeData: [],
      count: 0,
      rootLevel: [
        {
          id: "year_1",
          label: "JUNIOR HIGH SCHOOL - YEAR 1",
          order: 1,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "year_2",
          label: "JUNIOR HIGH SCHOOL - YEAR 2",
          order: 2,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "year_3",
          label: "JUNIOR HIGH SCHOOL - YEAR 3",
          order: 3,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        },
        {
          id: "demo",
          label: "Bett Brasil Demo",
          order: 4,
          children: [],
          textSubTitle: "",
          options: {
            titleClassArray: ["root-title"],
            showSubTitle: true,
          },
        }
      ],
      scenarioGroupMap: {
        "a1_0001_where-are-you-from_ja": "year_1",
        "a1_0003_do-you-play-basketball_ja": "year_1",
        "a1_0004_what-do-we-have-on_ja": "year_1",
        "a1_0005_when-do-you-practice_ja": "year_1",
        "a1_0006_what-time-is-it-in-ny_ja": "year_1",
        "a1-0007_what-did-you-do_ja": "year_1",
        "a1-0008_which-do-you-want_ja": "year_1",
        "a2-0007_i-feel-sick_ja": "year_1",
        "a2-0008_what-are-you-doing_ja": "year_1",
        "a2-0009_what-do-you-want-to-do-next_ja": "year_1",
        "a1_0002_how-was-your-vacation_ja": "year_2",
        "a2_0001_problem-with-my-room_ja": "year_2",
        "a2_0002_whats-your-favorite-food_ja": "year_2",
        "a2_0003_what-do-you-want-to-be_ja": "year_2",
        "a2_0004_what-time-should-i-be-home_ja": "year_2",
        "a2_0005_any-good-ideas_ja": "year_2",
        "a2_0006_which-animal-is-larger_ja": "year_2",
        "b1_0001_which-world-heritage-site_ja": "year_2",
        "b1_0002_im-afraid-i-cant_ja": "year_2",
        "b1_0003_my-favorite-place-is_ja": "year_2",
        "a2_0010_what-country-do-you-want-to-visit_ja": "year_3",
        "a2_0011_have-you-ever_ja": "year_3",
        "a2_0012_i-can-take-you_ja": "year_3",
        "a2_0013_have-you-finished-yet_ja": "year_3",
        "a2_0014_how-long-have-you-liked-them_ja": "year_3",
        "b1_0004_is-it-easy-for-you_ja": "year_3",
        "b1_0005_prepared-for-an-emergency_ja": "year_3",
        "b1_0006_the-person-i-respect_ja": "year_3",
        "b1_0007_whats-tanabata-festival_ja": "year_3",
        "b2_0001_lets-have-a-mini-debate_ja": "year_3",
        "a1_0009_where-do-animals-live_pt": "demo",
        "a2_0015_when-do-the-animals-eat_pt": "demo",
      },
    };
  },
  mounted() {
    this.parseData();
  },
  methods: {
    parseData() {
      if (!this.data) {
        return;
      }
      this.treeData = deepClone(this.rootLevel);
      const indexMap = this.getIndexMap(this.scenarioGroupMap);
      this.data.map(item => {
        // const scenario_id = encodeURIComponent(item.id);
        const leaf_node = {
          id: item.id,
          description: item.intro_description,
          featured_image: item.featured_image,
          bot_character_image_url: item.bot_character_image_url,
          objectives: item.objectives,
          options: {
            customContent: true,
          },
        };
        const second_level = {
          id: item.id,
          children: [leaf_node],
          label: item.name,
          cefr_level: mappingLevel[item.level]["en"],
          options: {
            titleClassArray: ["level-1-title"],
            showTags: true,
            showIcon: true,
            iconClassArray: ["elsa-level-down", "elsa-ai-lesson"],
            showListAction: true,
            assignAction: true,
            hideAddAction: true,
            asignActionText: this.$t("homework.scenarios.assign_to_class"),
          },
        };
        this.treeData.map(root => {
          if (this.scenarioGroupMap[item.id] === root.id) {
            second_level["order"] = indexMap[item.id];
            root.children.push(second_level);
          }
        });
      });
      this.treeData.map(root => {
        // sorting children by order field
        root.children.sort((a, b) => a.order - b.order);
        if (root.children.length > 1) {
          root.textSubTitle = root.children.length + " " + this.$t("common.lessons");
        } else if (root.children.length === 1) {
          root.textSubTitle = root.children.length + " " + this.$t("common.lesson");
        } else {
          // remove root level if no children
          this.treeData = this.treeData.filter(item => item.id !== root.id);
        }
      });
    },
    getTitlel(data) {
      return data.label;
    },
    handleAssign(node) {
      const scenario = {
        id: node.data.id,
        name: node.data.label,
      };
      this.$refs.addAssignment.handleAssignToClassScenario(scenario);
    },
    getIndexMap(object) {
      const keys = Object.keys(object); // Get all keys from the object
      const indexMap = {};
      keys.forEach((key, index) => {
        indexMap[key] = index;
      });
      return indexMap;
    }
  },
  watch: {
    data: {
      handler: function() {
        this.parseData();
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.tag {
  padding: 4px 8px;
  background: #efeff4;
  border-radius: 4px;
  text-transform: uppercase;
  margin-top: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.25px;
  color: #8e8e93;
}

.root-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #121131;
  font-family: sf-pro-text, sans-serif;
}

.level-1-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
}

.level-2-title {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
  font-weight: 400;
}
</style>
